import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LoginPrompt.css';

function LoginPrompt({ 
  title = 'برای ادامه باید وارد شی!',
  description = 'فقط یه لاگین سریع می‌خواد',
  returnTo = '/dashboard',
  onClose,
  isOpen = true
}) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleLogin = () => {
    navigate('/login', { state: { returnTo } });
    onClose?.();
  };

  return (
    <div className="login-prompt-overlay" onClick={onClose}>
      <div className="login-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <button className="login-prompt-close" onClick={onClose}>✕</button>
        
        <div className="login-prompt-icon">🔐</div>
        
        <h2 className="login-prompt-title">{title}</h2>
        <p className="login-prompt-description">{description}</p>

        <div className="login-benefits">
          <div className="login-benefit-item">
            <span className="benefit-icon">✅</span>
            <span>ذخیره تست‌ها</span>
          </div>
          <div className="login-benefit-item">
            <span className="benefit-icon">📊</span>
            <span>دیدن نتایج</span>
          </div>
          <div className="login-benefit-item">
            <span className="benefit-icon">🔗</span>
            <span>اشتراک‌گذاری</span>
          </div>
        </div>

        <button 
          className="btn-login-now"
          onClick={handleLogin}
        >
          ورود / ثبت‌نام
        </button>

        <p className="login-note">
          نگران نباش! بعد لاگین برمی‌گردیم همینجا 😊
        </p>
      </div>
    </div>
  );
}

export default LoginPrompt;